export type LetzteAusfuehrung =
  | { key: 'nie' | 'geradeEben' }
  | { key: 'minuten' | 'stunden' | 'tag' | 'tage'; n: number }
  | { key: 'datum'; datum: Date };

const MINUTE = 60_000;
const STUNDE = 60 * MINUTE;
const TAG = 24 * STUNDE;
const LETZTER_RELATIVER_TAG = 30;

export function letzteAusfuehrung(zeitpunkt: string | null | undefined, jetzt: Date): LetzteAusfuehrung {
  if (!zeitpunkt) return { key: 'nie' };
  const datum = new Date(zeitpunkt);
  if (Number.isNaN(datum.getTime())) return { key: 'nie' };

  const vergangen = jetzt.getTime() - datum.getTime();
  if (vergangen < MINUTE) return { key: 'geradeEben' };
  if (vergangen < STUNDE) return { key: 'minuten', n: Math.floor(vergangen / MINUTE) };
  if (vergangen < TAG) return { key: 'stunden', n: Math.floor(vergangen / STUNDE) };

  const tage = Math.floor(vergangen / TAG);
  if (tage === 1) return { key: 'tag', n: 1 };
  if (tage <= LETZTER_RELATIVER_TAG) return { key: 'tage', n: tage };
  return { key: 'datum', datum };
}
